export default __webpack_public_path__ + "static/media/blog-img83.ede49811.jpg";